import React from "react";

import Label from "../Label";

import { Align } from "./styles";

const Description = ({ name, value, color = "black" }) => {
    return (
        <Align>
            <Label size="nano" color={color} align="left" weight="700" padding="5px 0">
                {name}
            </Label>
            <Label size="nano" color={color} align="right" padding="5px 0">
                {value}
            </Label>
        </Align>
    );
};

export default Description;
